import axios from "axios"
import ls from "@/helper/ls"
import router from "@/router"

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API + "/api",
})

axiosInstance.interceptors.request.use(
  async (req) => {
    const lsData = ls.getKey("baltlan_ai")

    if (lsData) {
      req.headers.Authorization = `Bearer ${lsData.accessToken}`
    }

    return req
  },
  (error) => Promise.reject(error),
)

axiosInstance.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status) {
      switch (error.response.status) {
        case 400:
          return Promise.resolve({
            ...error.response,
            isError: true,
          })
        case 401:
          originalRequest._retry = true
          try {
            const lsData = ls.getKey("baltlan_ai")

            const response = await axios.get(
              import.meta.env.VITE_APP_API + "/api/auth/refresh",
              {
                headers: {
                  Authorization: `Bearer ${lsData.refreshToken}`,
                },
              },
            )

            const { accessToken } = response.data

            ls.setKey("baltlan_ai", response.data)

            axiosInstance.defaults.headers.common["Authorization"] =
              `Bearer ${accessToken}`
            return axiosInstance(originalRequest)
          } catch (refreshError) {
            localStorage.removeItem("baltlan_ai")
            window.location.href = "/login"
            return Promise.reject({ isError: true, ...refreshError })
          }
        case 403:
          return Promise.resolve({ isError: true, ...error.response })
        case 404:
          router.replace({
            path: "/notfound",
            query: { redirect: router.currentRoute.fullPath },
          })
          break
        case 500: {
          return Promise.resolve({
            ...error.response,
            isError: true,
          })
        }
        case 502:
          return Promise.resolve({ isError: true, ...error.response })
        case 405: {
          return Promise.resolve({
            ...error.response,
            isError: true,
          })
        }
      }
      return Promise.reject({
        ...error.response,
        isError: true,
      })
    }
  },
)

export default axiosInstance
